import gql from "graphql-tag";

export const GET_ORDERS_LIST = gql`
  query workshopOrders(
    $first: Int
    $after: String
    $before: String
    $last: Int
    $direction: OrderDirection!
    $search: String
    $isInspected: Boolean
    $isQuoted: Boolean
    $workshop: ID
    $field: WorkshopOrderSortField!
    $isQuoteRequired: Boolean
    $status: [ServiceOrderStatusEnum]
    $hasApprovedQuotation: Boolean
    $gte: Date
    $lte: Date
    $gte_quoted: Date
    $lte_quoted: Date
    $isPendingAcceptance: Boolean
    $isFullyQuoted: Boolean
    $isAssignedToMe: Boolean
    $isLpoReceived: Boolean
    $carMake: ID
  ) {
    workshopOrders(
      first: $first
      after: $after
      before: $before
      last: $last
      filter: {
        search: $search
        status: $status
        isInspected: $isInspected
        isQuoteRequired: $isQuoteRequired
        scheduledAt: { gte: $gte, lte: $lte }
        hasApprovedQuotation: $hasApprovedQuotation
        isQuoted: $isQuoted
        workshop: $workshop
        workshopQuotedAt: { gte: $gte_quoted, lte: $lte_quoted }
        isPendingAcceptance: $isPendingAcceptance
        isFullyQuoted: $isFullyQuoted
        isAssignedToMe: $isAssignedToMe
        isLpoReceived: $isLpoReceived
        carMake: $carMake
      }
      sortBy: { direction: $direction, field: $field }
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          number
          status
          workshopQuotedAt
          workshopAssignedAt
          workshopAcceptedBy {
            firstName
            lastName
          }
          car {
            model {
              id
              name
              make {
                id
                name
              }
            }
            licensePlate
          }
          assignedTo {
            firstName
            lastName
            phone
          }
          isQuoteRequired
          approvedQuotation
          scheduledAt
          isFullyQuoted
          lines {
            service {
              id
              type {
                name
                description
              }
            }
            serviceName
          }
        }
      }
    }
  }
`;

export const GET_ORDER_DETAILS = gql`
  query workshopOrder($id: ID!) {
    workshopOrder(id: $id) {
      number
      currency
      status
      car {
        model {
          id
          name
          make {
            id
            name
          }
        }
        licensePlate
        year
        vin
      }
      scheduledAt
      workshopQuotedAt
      workshopAssignedAt
      workshopAcceptedBy {
        firstName
        lastName
      }
      workshop
      workshopExpectedCompletionAt
      labourHours
      totalHoursRequired
      totalHoursTaken
      labourRatePerHour {
        amount
        currency
      }
      labourPrice {
        amount
        currency
      }
      workshopExpectedCompletionDays
      partsJob {
        id
        type
        status
        assignedTo {
          firstName
          lastName
          phone
        }
        scheduledAt
        notes
        possibleActions
        createdAt
        updatedAt
        isStarted
        isCompleted
      }
      workshopJobs {
        id
        status
        type
        scheduledAt
        scheduledUpto
        notes
        hoursRequired
        hoursTaken
        createdAt
        updatedAt
        isStarted
        isCompleted
        assignedTo {
          firstName
          lastName
          phone
        }
      }
      canSendToTrello
      assignedTo {
        firstName
        lastName
        phone
      }
      isFullyQuoted
      lines {
        service {
          id
          type {
            name
            description
          }
        }
        serviceName
      }
      partQuotations {
        id
        partName
        priceSupplier {
          currency
          amount
        }
        unitPriceSupplier {
          amount
          currency
        }
        quantity
        quality
        availability
        status
        createdAt
        createdBy {
          firstName
          lastName
        }
        partNumber
        brand
      }
      customerNote
      staffNote
      valetNote
      isQuoteRequired
      workshopTrackingPdfUrl
      attachments {
        file
        filename
        extension
        uploadedAt
        uploadedBy {
          firstName
        }
      }
      approvedQuotation
      partsLpo
      comments {
        comment
        createdAt
        createdBy {
          firstName
          lastName
        }
      }
    }
  }
`;

export const MY_WORKSHOPS = gql`
  query myWorkshops {
    myWorkshops {
      id
      name
      phone
      address
      location {
        lat
        lng
      }
      contactPerson {
        firstName
        lastName
        phone
        email
      }
    }
  }
`;

export const GET_CAR_MAKE = gql`
  query {
    vehicleMakes {
      id
      isPopular
      logo
      name
    }
  }
`;

export const GET_CAR_MODEL = gql`
  query getModels($makeId: ID!) {
    vehicleModels(makeId: $makeId) {
      id
      name
      years
      image
      classification
    }
  }
`;

export const MY_JOBS = gql`
  query myJobs(
    $first: Int
    $after: String
    $before: String
    $last: Int
    $search: String
    $status: JobStatusFilterEnum
    $type: [JobTypeEnum!]
    $isActive: Boolean
    $isCompleted: Boolean
  ) {
    myJobs(
      first: $first
      after: $after
      before: $before
      last: $last
      filter: {
        search: $search
        status: $status
        type: $type
        isActive: $isActive
        isCompleted: $isCompleted
      }
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          type
          status
          scheduledAt
          updatedAt
          order {
            number
            status
            car {
              model {
                name
                make {
                  name
                }
              }
              licensePlate
            }
          }
        }
      }
    }
  }
`;

export const GET_WORKSHOP_JOBS = gql`
  query workshopJobs(
    $first: Int
    $after: String
    $before: String
    $last: Int
    $search: String
    $status: [JobStatusEnum!]
    $type: JobTypeEnum
    $scheduledAt: DateRangeInput
    $scheduledUpto: DateRangeInput
    $workshop: ID
  ) {
    workshopJobs(
      first: $first
      after: $after
      before: $before
      last: $last
      filter: {
        type: $type
        status: $status
        scheduledAt: $scheduledAt
        scheduledUpto: $scheduledUpto
        workshop: $workshop
        search: $search
      }
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          type
          status
          scheduledAt
          scheduledUpto
          assignedTo {
            firstName
            lastName
            phone
          }
          notes
          isStarted
          isCompleted
          updatedAt
          order {
            number
            status
            car {
              model {
                name
                make {
                  name
                }
              }
              licensePlate
            }
          }
          workshopScheduleStart
          workshopScheduleEnd
          workshopBreakStart
          workshopBreakEnd
        }
      }
    }
  }
`;

export const GET_JOB_USERS = gql`
  query jobUsers($jobID: ID!, $first: Int, $search: String) {
    jobUsers(jobId: $jobID, first: $first, filter: { search: $search }) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          firstName
          lastName
          jobProfile {
            type
          }
        }
      }
    }
  }
`;

export const PARTS_ENQUIRY_GROUPS_LIST = gql`
  query WorkshopEnquiryGroups(
    $first: Int
    $search: String
    $after: String
    $before: String
    $last: Int
    $isFullyQuoted: Boolean
    $hasOrder: Boolean
    $carMake: ID
    $gte: Date
    $lte: Date
    $direction: OrderDirection!
    $field: EnquiryGroupSortField!
    $isQuoted: Boolean
  ) {
    workshopEnquiryGroups(
      first: $first
      after: $after
      last: $last
      before: $before
      sortBy: { direction: $direction, field: $field }
      filter: {
        search: $search
        isFullyQuoted: $isFullyQuoted
        hasOrder: $hasOrder
        carMake: $carMake
        createdAt: { gte: $gte, lte: $lte }
        isQuoted: $isQuoted
      }
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
      edges {
        node {
          id
          number
          car {
            id
            model {
              name
              make {
                name
              }
            }
            licensePlate
            vin
          }
          enquiries {
            id
            position
            details
            quantity
            section
          }
          createdAt
          createdBy {
            firstName
            lastName
          }
          order {
            id
            number
          }
          isFullyQuoted
        }
      }
    }
  }
`;

export const PARTS_ENQUIRY_GROUP = gql`
  query WorkshopEnquiryGroup($id: ID!) {
    workshopEnquiryGroup(id: $id) {
      id
      number
      car {
        classification
        id
        licensePlate
        model {
          make {
            name
            id
          }
          name
          id
        }
        year
        vin
        registrationCard {
          front
          back
          backExtension
          frontExtension
        }
        mileage
        mileageUpdatedAt
        nextServiceMileage
        nextServiceDue
        hasActiveSubscription
        registrationRenewalAt
        insuranceRenewalAt
      }
      enquiries {
        id
        position
        details
        quantity
        section
      }
      createdAt
      createdBy {
        firstName
        lastName
      }
      order {
        id
        number
      }
      partQuotations {
        id
        partName
        position
        priceSupplier {
          amount
          currency
        }
        availability
        quality
        quantity
        partNumber
        brand
        status
        createdBy {
          firstName
          lastName
        }
        createdAt
        unitPriceSupplier {
          amount
          currency
        }
      }
      comments {
        comment
        createdAt
        createdBy {
          firstName
          lastName
        }
      }
      attachments {
        title
        file
        uploadedAt
        uploadedBy {
          firstName
          lastName
        }
      }
      isFullyQuoted
      notes
    }
  }
`;
